import { getUser } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useUserById = (id: string | undefined) => {
  const {
    data,
    isValidating: userLoading,
    error: userError,
  } = useSWR(id ? id : null, getUser, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    user: data,
    userLoading,
    userError,
  };
};

export default useUserById;
